<h1>Add Category</h1>

<form [formGroup]="addCategoryForm" (ngSubmit)="createCategory()">
  <mat-form-field>
    <mat-label>Name</mat-label>
    <input matInput
           aria-label="Category Name"
           type="text"
           autocomplete="off"
           formControlName="name" (change)="setSlug($event)" />
    <mat-hint>The name is how it appears throughout your site.</mat-hint>
    <mat-error *ngIf="name!.hasError('required') && !name!.untouched">Name is <strong>required</strong></mat-error>
  </mat-form-field>

  <mat-form-field>
    <mat-label>Slug</mat-label>
    <input matInput
           aria-label="Category Slug"
           type="text"
           autocomplete="off"
           formControlName="slug" />
    <mat-hint>Auto populates from the above <em>name</em> field!<br />
      The "slug" is the URL friendly version of the name.
      It is usually all lowercase and contains only
      letters, numbers, and hyphens.</mat-hint>
    <mat-error *ngIf="slug!.hasError('required')">
      Slug is <strong>required</strong>, but will auto populate from the above <em>name</em> field.
    </mat-error>
  </mat-form-field>

  <mat-form-field>
    <mat-label>Description</mat-label>
    <textarea matInput type="text" aria-label="Category Description" formControlName="description"></textarea>
    <mat-hint>The description is not required, however,
      some times it may be shown throughout your site if set.</mat-hint>
  </mat-form-field>

  <mat-checkbox formControlName="featured">Featured</mat-checkbox>

  <p [style.text-align]="'center'">
    <button
      mat-raised-button
      type="submit"
      color="accent"
      [disabled]="addCategoryForm.invalid">Add Category</button>
  </p>
</form>
